import dayjs from 'dayjs';
import { StateCreator } from 'zustand';

export interface PatientListSlice {
    globalUsecaseFilter: string[];
    globalStatusFilter: string[];
    globalStartDateFilter: dayjs.Dayjs;
    globalEndDateFilter: dayjs.Dayjs;
    globalTaskOwnerFilter: string;
    globalClientFilter: string[] | null;
    globalTaskFilter: string[];
    setGlobalUsecaseFilter: (usecase: string[]) => void;
    setGlobalStatusFilter: (status: string[]) => void;
    setGlobalStartDateFilter: (date: dayjs.Dayjs) => void;
    setGlobalEndDateFilter: (date: dayjs.Dayjs) => void;
    setGlobalTaskOwnerFilter: (owner: string) => void;
    setGlobalClientFilter: (client: string[] | null) => void;
    setGlobalTaskFilter: (task: string[]) => void;
    resetFilters: () => void;
}

const initialPatientListState = {
    globalUsecaseFilter: ['all'],
    globalStatusFilter: ['not_started', 'active'],
    globalStartDateFilter: dayjs().subtract(7, 'days').startOf('day'),
    globalEndDateFilter: dayjs().endOf('day'),
    globalTaskOwnerFilter: 'all',
    globalClientFilter: ['all'],
    globalTaskFilter: ['all']
};

export const createPatientListSlice: StateCreator<PatientListSlice> = (set, get) => ({
    ...initialPatientListState,
    setGlobalUsecaseFilter: (usecase: string[]) => {
        set({ globalUsecaseFilter: usecase });
    },
    setGlobalStatusFilter: (status: string[]) => {
        set({ globalStatusFilter: status });
    },
    setGlobalStartDateFilter: (date: dayjs.Dayjs) => {
        set({ globalStartDateFilter: date });
    },
    setGlobalEndDateFilter: (date: dayjs.Dayjs) => {
        set({ globalEndDateFilter: date });
    },
    setGlobalTaskOwnerFilter: (owner: string) => {
        set({ globalTaskOwnerFilter: owner });
    },
    setGlobalClientFilter: (client: string[] | null) => {
        set({ globalClientFilter: client });
    },
    setGlobalTaskFilter: (task: string[]) => {
        set({ globalTaskFilter: task });
    },
    resetFilters: () => {
        set({
            ...initialPatientListState
        });
    }
});
